import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';
import type {
    CalendarSchedulingEntrySource,
    SchedulingTimeRange,
    SchedulingDialogAnchor,
} from '../store/store';

export const openCalendarSchedulingDialogMutator: (
    entrySource: CalendarSchedulingEntrySource,
    timeRange?: SchedulingTimeRange,
    anchor?: SchedulingDialogAnchor
) => void = mutatorAction(
    'OPEN_CALENDAR_SCHEDULING_DIALOG',
    (
        entrySource: CalendarSchedulingEntrySource,
        timeRange?: SchedulingTimeRange,
        anchor?: SchedulingDialogAnchor
    ): void => {
        const store = getStore();
        store.entrySource = entrySource;
        store.timeRange = timeRange;
        store.anchor = entrySource === 'SurfaceContextMenu' ? anchor : undefined;
        store.isOpen = true;
    }
);

export const closeCalendarSchedulingDialogMutator: () => void = mutatorAction(
    'CLOSE_CALENDAR_SCHEDULING_DIALOG',
    (): void => {
        const store = getStore();
        store.isOpen = false;
        store.entrySource = undefined;
        store.timeRange = undefined;
        store.anchor = undefined;
    }
);
